
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 64 64","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M21 19.8l-6.9 8.3h-.3c-2.3 0-4.1 1.8-4.1 4.1v6.2h4.1c0 3.4 2.8 6.2 6.2 6.2s6.2-2.8 6.2-6.2h12.4c0 3.4 2.8 6.2 6.2 6.2 3.4 0 6.2-2.8 6.2-6.2h4.1v-6.2c0-2.3-1.8-4.1-4.1-4.1h-4.1l-6.2-8.3H21zm1.1 3.1h7.3v5.2H17.9l4.2-5.2zm10.3 0h7.2l4 5.2H32.4v-5.2M20 35.3c1.7 0 3.1 1.4 3.1 3.1s-1.4 3.1-3.1 3.1c-1.7 0-3.1-1.4-3.1-3.1s1.4-3.1 3.1-3.1m24.8 0c1.7 0 3.1 1.4 3.1 3.1s-1.4 3.1-3.1 3.1c-1.7 0-3.1-1.4-3.1-3.1s1.4-3.1 3.1-3.1z"}})])
          )
        }
      }
    